import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useCart } from "../context/CartContext";
import { setPassportNotice } from "../lib/passportNotice";

export const PassportHandoff = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { replaceFoodCart, setChannel } = useCart();
  const busy = useRef(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get("passport_cart");
    if (!code || busy.current) return;
    busy.current = true;
    const wantedDelivery = (params.get("fulfillment") || "pickup").toLowerCase() === "delivery";
    const landing = location.pathname === "/" ? "/store/restaurant" : location.pathname;

    api.get(`/passport/cart-handoff/${encodeURIComponent(code)}`)
      .then(({ data }) => {
        setChannel("pickup");
        if (data.resolved.length > 0) {
          replaceFoodCart(data.resolved.map((r) => ({ product: r.product, qty: r.qty })));
          setPassportNotice({
            type: data.unresolved.length ? "partial" : "ok",
            added: data.resolved.length,
            missing: data.unresolved,
            deliverySwitched: wantedDelivery,
          });
          navigate("/checkout", { replace: true });
        } else {
          setPassportNotice({ type: "none_resolved", added: 0, missing: data.unresolved, deliverySwitched: wantedDelivery });
          navigate("/store/restaurant", { replace: true });
        }
      })
      .catch((e) => {
        setPassportNotice({
          type: "failed",
          detail: e.response?.data?.detail || "We couldn't carry your saved order across. Please add your dishes from the menu below — it only takes a moment.",
          missing: [], added: 0, deliverySwitched: false,
        });
        navigate(landing, { replace: true });
      })
      .finally(() => { busy.current = false; });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  return null;
};
